import { useQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getEarnStatistics } from 'services/EarnService'

export const useEarnStatisticsQuery = () => {
  return useQuery({
    queryKey: reactQueryKeys.earnStatistics(),
    queryFn: getEarnStatistics,
  })
}
